import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomRateExtraGuestSurcharges(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<App.ExtraGuestSurcharges>>({
    queryKey: roomRateAvailabilityQueryKeys.extraGuestSurcharges(propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''),
    queryFn: async () =>
      (await ReservationService.getExtraGuestSurcharges(propertyId, roomTypeId, roomRateId)).result?.surcharges ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
